import { put, takeLatest } from "redux-saga/effects";
import { requestHeadCountDetailsList, requestUpdateLocationAreaDetails } from "services/acclgl/reports/headCountDetails";
import {
  fetchHeadCountDetailsListRequest,
  fetchHeadCountDetailsListSuccess,
  fetchHeadCountDetailsListFailure,
  updateLocationAreaDetailsRequest,
  updateLocationAreaDetailsSuccess,
  updateLocationAreaDetailsFaliure,
} from "redux/reducers/acclgl/reports/headCountDetails";
export function* watchHeadCountDetailsSaga() {
  yield takeLatest(fetchHeadCountDetailsListRequest, fetchHeadCountDetailsList);
  yield takeLatest(updateLocationAreaDetailsRequest, updateLocationAreaDetails);
}

function* fetchHeadCountDetailsList({ payload }) {
  try {
    const response = yield requestHeadCountDetailsList(payload);
    yield put(fetchHeadCountDetailsListSuccess(response));
  } catch (error) {
    yield put(
      fetchHeadCountDetailsListFailure("Failed to get list of reports")
    );
  }
}
function* updateLocationAreaDetails({ payload }) {
  try {
    const response = yield requestUpdateLocationAreaDetails(payload);
    console.log(response)
    yield put(updateLocationAreaDetailsSuccess(response));
  } catch (error) {
    yield put(
      updateLocationAreaDetailsFaliure("Failed to update location area Details")
    );
  }
}

